export const userPic = require('./user.png');

export const CTPIconNotSelected = require('./players_scoring_tabs_icons/icon-ctp-not_selected.png');
export const CTPIconSelected = require('./players_scoring_tabs_icons/icon-ctp-selected.png');

export const HorseRaceIconNotSelected = require('./players_scoring_tabs_icons/icon-horse_race-not_selected.png');
export const HorseRaceIconSelected = require('./players_scoring_tabs_icons/icon-horse_race-selected.png');

export const IndividualIconNotSelected = require('./players_scoring_tabs_icons/icon-individual_leaderboard-not_selected.svg');
export const IndividualIconSelected = require('./players_scoring_tabs_icons/icon-individual_leaderboard-selected.svg');

export const MoneyBallIconNotSelected = require('./players_scoring_tabs_icons/icon-money_ball-not_selected.svg');
export const MoneyBallIconSelected = require('./players_scoring_tabs_icons/icon-money_ball-selected.svg');

export const ScrambleIconNotSelected = require('./players_scoring_tabs_icons/icon-scramble-not_selected.png');
export const ScrambleIconSelected = require('./players_scoring_tabs_icons/icon-scramble-selected.png');

export const SkinsIconNotSelected = require('./players_scoring_tabs_icons/icon-skins-not_selected.svg');
export const SkinsIconSelected = require('./players_scoring_tabs_icons/icon-skins-selected.svg');

export const redWaglLogo = require('./logo/redWaglLogo.svg');
export const darkWaglLogo = require('./logo/darkWaglLogo.svg');

export const menuIcon = require('./icons/menu.svg');
export const whiteWaglLogo = require('./logo/whiteWaglLogo.svg');

export const defaultClubLogo = require('./club-logo.svg');
export const placeholderImage = require('./Artboard.png');

export const TagSelected = require('./tag-selected.svg');
export const TagOutline = require('./tag-outline.svg');
export const PlayerOutline = require('./player-blank.svg');

export const EventCardDefaultBackground = require('./event-card-default-bg.png');

export const SpeakerIcon = require('./speaker.svg');

export const SimpleScorcardsIcon = require('./icons/simple_scorecards_icon.png');

// Menu Icons
export const addNewClubIcon = require('./menu_icons/add_new_club.png');
export const clubHouseLogo = require('./menu_icons/club_house.png');
export const settingsLogo = require('./menu_icons/club_settings.png');
export const eventsLogo = require('./menu_icons/events.png');
export const clubHouseIcon = require('./menu_icons/goto_clubhouse.png');
export const financesLogo = require('./menu_icons/ledger.png');
export const rosterLogo = require('./menu_icons/player_roster.png');
export const leaderboardLogo = require('./menu_icons/standings.png');
